export type WorldWarp = {
    name: string;
    world?: string;
    x: number;
    y: number;
    z: number;
    yaw?: number;
    pitch?: number;
    lastowner?: string;
};
export declare const server: (serv: Server, options: Options) => Promise<void>;
declare global {
    interface Server {
        warps: WorldWarp[];
    }
}
